<template>
  <div class="grade-scale">
    <span class="grade-scale__caption">Grade</span>
    <button
      v-for="grade in grades"
      :key="grade"
      type="button"
      class="grade-scale__step"
      :class="{
        'is-current': grade === currentGrade,
        'is-milestone': milestones.includes(grade),
      }"
      :title="milestoneLabel(grade)"
      @click="$emit('select', grade)"
    >
      {{ grade }}
    </button>
    <span class="grade-scale__legend">10 beginner → 0 master</span>
  </div>
</template>

<script setup>
defineProps({
  grades: { type: Array, required: true },
  currentGrade: { type: Number, required: true },
});

defineEmits(['select']);

// The three grades a school opens at. They are where a build changes shape, so
// they are the grades worth checking a balance question at.
const milestones = [9, 4, 0];

const MILESTONE_LABELS = {
  9: 'Primary school opens',
  4: 'Limited school opens',
  0: 'Secondary school opens',
};

function milestoneLabel(grade) {
  return MILESTONE_LABELS[grade] ?? `Grade ${grade}`;
}
</script>

<style scoped>
.grade-scale {
  display: flex;
  align-items: center;
  gap: var(--gm-gap-xs);
  flex-wrap: wrap;
}

.grade-scale__caption {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--gm-text-muted);
  margin-right: var(--gm-gap-xs);
}

.grade-scale__step {
  min-width: 2rem;
  padding: 0.25rem 0.4rem;
  font: inherit;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  color: var(--gm-text-muted);
  background: var(--gm-surface-1);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius-sm);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.grade-scale__step:hover {
  border-color: var(--gm-border);
  color: var(--gm-text);
}

.grade-scale__step.is-milestone {
  border-bottom-width: 2px;
  border-bottom-color: var(--gm-accent);
}

.grade-scale__step.is-current {
  color: var(--gm-surface-sunken);
  background: var(--gm-accent);
  border-color: var(--gm-accent);
  font-weight: 700;
}

.grade-scale__legend {
  margin-left: var(--gm-gap-sm);
  font-size: 0.62rem;
  font-style: italic;
  color: var(--gm-text-dim);
}
</style>
